'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shouldComponentUpdate = require('./shouldComponentUpdate');

var _shouldComponentUpdate2 = _interopRequireDefault(_shouldComponentUpdate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  shouldComponentUpdate: _shouldComponentUpdate2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/react-immutable-render-mixin/lib/immutableRenderMixin.js
// module id = 825
// module chunks = 1 2